import { createFileRoute } from '@tanstack/react-router'

import CreatePoktanPage from '@/components/pages/backoffice/_klb-petani/_poktan/_create/containers/CreatePoktanPage'

export const Route = createFileRoute('/_backoffice/klb-petani/poktan/create/')({
  component: CreatePoktanPage
})
